import styled from 'styled-components';
import MobileOtp from '../../assets/onboarding/mobile.svg';

const MobileOtpIcon = styled(MobileOtp as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.4rem'};
height: ${props => props.height || '2.6rem'};
display: flex;
`;

export default MobileOtpIcon;
